(() => {
  const root = document.querySelector('[data-quiz-root]');
  if (!root) return;

  const STORAGE_KEY = 'zb_find_your_ritual_v1';
  const QUIZ_NAME = 'find_your_ritual';
  const questionEl = root.querySelector('[data-quiz-question]');
  const resultEl = root.querySelector('[data-quiz-result]');
  const emailEl = root.querySelector('[data-quiz-email]');
  const progressEl = root.querySelector('[data-quiz-progress]');

  const questions = [
    {
      id: 'begin',
      prompt: 'Where would you like to begin?',
      options: [
        { id: 'morning', label: 'My morning feels scattered', ritual: 'groundedDawn', concern: 'morning' },
        { id: 'skin', label: 'My skin feels depleted', ritual: 'quietNourish', concern: 'skin' },
        { id: 'release', label: 'I need to unwind', ritual: 'pressRelease', concern: 'tension' },
        { id: 'evening', label: 'I want a softer evening', ritual: 'softLanding', concern: 'evening' },
      ],
    },
    {
      id: 'care',
      prompt: 'What kind of care are you reaching for today?',
      options: [
        { id: 'steady', label: 'A steadying start', ritual: 'groundedDawn', concern: 'morning' },
        { id: 'restore', label: 'A little more nourishment', ritual: 'quietNourish', concern: 'skin' },
        { id: 'unclench', label: 'A way to soften tension', ritual: 'pressRelease', concern: 'tension' },
        { id: 'slow', label: 'A slower landing', ritual: 'softLanding', concern: 'evening' },
      ],
    },
    {
      id: 'space',
      prompt: 'When would you most welcome a little more space?',
      options: [
        { id: 'first-light', label: 'At first light', ritual: 'groundedDawn', concern: 'morning' },
        { id: 'between-things', label: 'Between the things I carry', ritual: 'pressRelease', concern: 'tension' },
        { id: 'after-screen', label: 'After a long screen day', ritual: 'quietNourish', concern: 'skin' },
        { id: 'before-bed', label: 'Just before bed', ritual: 'softLanding', concern: 'evening' },
      ],
    },
    {
      id: 'texture',
      prompt: 'What would feel most like care today?',
      options: [
        { id: 'tea', label: 'A warm cup held slowly', ritual: 'groundedDawn', concern: 'morning' },
        { id: 'oil', label: 'A few drops pressed into skin', ritual: 'quietNourish', concern: 'skin' },
        { id: 'touch', label: 'The rhythm of intentional touch', ritual: 'pressRelease', concern: 'tension' },
        { id: 'stillness', label: 'A room made a little quieter', ritual: 'softLanding', concern: 'evening' },
      ],
    },
  ];

  const rituals = {
    groundedDawn: {
      title: 'The Grounded Dawn Ritual',
      subtitle: 'A clearer beginning, one quiet step at a time.',
      copy: 'For mornings that arrive quickly, this ritual makes room for warmth, breath, and a steadier pace before the day asks anything of you.',
      why: 'You are looking for a sense of rhythm before you reach for more.',
      botanical: 'Ginseng + green tea',
      steps: ['Warm a cup of botanical tea.', 'Take three unhurried breaths before the first sip.', 'Choose one small intention for the morning.'],
      product: { title: 'Astragalus Herbal Tea', href: '/products/ginseng-five-treasure-tea-turmeric-cinnamon-ginger-hibiscus-chamomile-eight-treasure-tea-ginseng-ten-treasure-tea' },
      journal: { title: 'The Weekly Botanical Reset', href: '/blogs/journal/weekly-botanical-reset' },
    },
    quietNourish: {
      title: 'The Quiet Nourish Ritual',
      subtitle: 'A softer touch for skin that wants to be replenished.',
      copy: 'For days when your skin and your attention both feel spent, this is a simple return to warmth, texture, and a little more time.',
      why: 'You are drawn to care that feels restorative without becoming another task.',
      botanical: 'Ginseng + tremella',
      steps: ['Warm a small amount of oil between your palms.', 'Press over clean skin, starting at the center of the face.', 'Pause with both hands at the cheeks and jaw.'],
      product: { title: 'Ginseng Botanical Face Oil', href: '/products/ginseng-gold-essence-moisturizing-and-nourishing-facial-niacinamide-skincare-serum' },
      journal: { title: 'An Evening Facial Oil Ritual', href: '/blogs/journal/evening-facial-oil-ritual' },
    },
    pressRelease: {
      title: 'The Press & Release Ritual',
      subtitle: 'A small ritual for the tension you carry.',
      copy: 'For the moments when your shoulders have moved closer to your ears, this practice gives touch a slower rhythm and the body a little more room.',
      why: 'You are ready for care that is felt through the hands, not added to the list.',
      botanical: 'Mugwort + jade',
      steps: ['Apply a few drops of facial oil for slip.', 'Use slow outward strokes across the jaw and cheek.', 'Finish with a still palm and one long exhale.'],
      product: { title: 'Rose Quartz Massage Stick', href: '/products/rose-quartz-jade-massage-stick-beauty-device-facial-scraper-crystal-beauty-instrument-jade-roller-set-jade-products-wholesale' },
      journal: { title: 'A Five-Minute Gua Sha Morning', href: '/blogs/journal/five-minute-gua-sha-morning' },
    },
    softLanding: {
      title: 'The Soft Landing Ritual',
      subtitle: 'A gentler way to close the day.',
      copy: 'For evenings that need a little less noise, this ritual creates a small threshold between what happened and what comes next.',
      why: 'You are looking for a graceful ending rather than another thing to accomplish.',
      botanical: 'Astragalus + warm tea',
      steps: ['Dim the room and set your phone aside.', 'Make a warm cup and let the first few minutes be quiet.', 'Write down one thing you can leave for tomorrow.'],
      product: { title: 'Astragalus Herbal Tea', href: '/products/ginseng-five-treasure-tea-turmeric-cinnamon-ginger-hibiscus-chamomile-eight-treasure-tea-ginseng-ten-treasure-tea' },
      journal: { title: 'Explore the Journal', href: '/blogs/journal' },
    },
  };

  const concernLabels = {
    morning: 'a more grounded morning',
    skin: 'skin that feels nourished',
    tension: 'a little more release',
    evening: 'a softer evening',
  };

  const defaultState = () => ({ index: 0, answers: [] });
  let state = readState();

  function readState() {
    try {
      const saved = window.sessionStorage.getItem(STORAGE_KEY);
      if (!saved) return defaultState();
      const parsed = JSON.parse(saved);
      return {
        index: typeof parsed.index === 'number' ? parsed.index : 0,
        answers: Array.isArray(parsed.answers) ? parsed.answers : [],
      };
    } catch (error) {
      return defaultState();
    }
  }

  function saveState() {
    try {
      window.sessionStorage.setItem(STORAGE_KEY, JSON.stringify(state));
    } catch (error) {
      // The quiz remains usable when storage is unavailable.
    }
  }

  function track(eventName, detail = {}) {
    const payload = Object.assign({ quiz: QUIZ_NAME }, detail);
    document.dispatchEvent(new CustomEvent(eventName, { detail: payload }));
    window.dispatchEvent(new CustomEvent(eventName, { detail: payload }));
    const shopifyAnalytics = window.Shopify && window.Shopify.analytics;
    if (shopifyAnalytics && typeof shopifyAnalytics.publish === 'function') {
      try {
        shopifyAnalytics.publish(eventName, payload);
      } catch (error) {
        // Analytics should never interrupt the ritual flow.
      }
    }
  }

  function getOption(questionIndex, optionId) {
    const question = questions[questionIndex];
    return question ? question.options.find((option) => option.id === optionId) : undefined;
  }

  function getResult() {
    const ritualScores = { groundedDawn: 0, quietNourish: 0, pressRelease: 0, softLanding: 0 };
    const concernScores = { morning: 0, skin: 0, tension: 0, evening: 0 };

    state.answers.forEach((answerId, questionIndex) => {
      const option = getOption(questionIndex, answerId);
      if (!option) return;
      ritualScores[option.ritual] += questionIndex === 0 ? 2 : 1;
      concernScores[option.concern] += 1;
    });

    const primary = Object.entries(ritualScores).sort((a, b) => b[1] - a[1])[0][0];
    const concern = Object.entries(concernScores).sort((a, b) => b[1] - a[1])[0][0];
    return { primary, concern, ritual: rituals[primary] };
  }

  function createButton(label, className, onClick) {
    const button = document.createElement('button');
    button.type = 'button';
    button.className = className;
    button.textContent = label;
    button.addEventListener('click', onClick);
    return button;
  }

  function renderQuestion() {
    const question = questions[state.index];
    if (!question) return renderResult();

    progressEl.textContent = `${String(state.index + 1).padStart(2, '0')} / ${String(questions.length).padStart(2, '0')}`;
    questionEl.hidden = false;
    resultEl.hidden = true;
    emailEl.hidden = true;
    questionEl.replaceChildren();

    const fieldset = document.createElement('fieldset');
    const legend = document.createElement('legend');
    legend.textContent = question.prompt;
    fieldset.appendChild(legend);

    question.options.forEach((option, optionIndex) => {
      const label = document.createElement('label');
      label.className = 'zb-quiz__option';

      const input = document.createElement('input');
      input.type = 'radio';
      input.name = question.id;
      input.value = option.id;
      input.checked = state.answers[state.index] === option.id;
      input.addEventListener('change', () => {
        state.answers[state.index] = option.id;
        saveState();
        renderQuestion();
        track('quiz_question_answered', { question: question.id, questionIndex: state.index + 1, answer: option.id });
      });

      const text = document.createElement('span');
      text.className = 'zb-quiz__option-label';
      const index = document.createElement('span');
      index.className = 'zb-quiz__option-index';
      index.textContent = String(optionIndex + 1).padStart(2, '0');
      const copy = document.createElement('span');
      copy.textContent = option.label;
      const arrow = document.createElement('span');
      arrow.className = 'zb-quiz__option-arrow';
      arrow.setAttribute('aria-hidden', 'true');
      arrow.textContent = '->';
      text.append(index, copy, arrow);
      label.append(input, text);
      fieldset.appendChild(label);
    });

    const actions = document.createElement('div');
    actions.className = 'zb-quiz__actions';
    if (state.index > 0) {
      actions.appendChild(createButton('BACK', 'zb-quiz__back', () => {
        state.index -= 1;
        saveState();
        renderQuestion();
      }));
    } else {
      actions.appendChild(document.createElement('span'));
    }

    const continueButton = createButton('CONTINUE ->', 'zb-quiz__button', () => {
      if (!state.answers[state.index]) return;
      if (state.index === questions.length - 1) {
        renderResult();
      } else {
        state.index += 1;
        saveState();
        renderQuestion();
      }
    });
    continueButton.disabled = !state.answers[state.index];
    actions.appendChild(continueButton);
    questionEl.append(fieldset, actions);
  }

  function renderResult() {
    const { primary, concern, ritual } = getResult();
    state.index = questions.length;
    saveState();
    questionEl.hidden = true;
    resultEl.hidden = false;
    emailEl.hidden = false;
    progressEl.textContent = 'YOUR RESULT';
    resultEl.replaceChildren();

    const heading = document.createElement('div');
    heading.className = 'zb-quiz__result-heading';
    const headingCopy = document.createElement('div');
    const eyebrow = document.createElement('p');
    eyebrow.className = 'zb-quiz__eyebrow';
    eyebrow.textContent = 'YOUR RITUAL';
    const title = document.createElement('h2');
    title.className = 'zb-quiz__result-title';
    title.textContent = ritual.title;
    const subtitle = document.createElement('p');
    subtitle.className = 'zb-quiz__result-copy';
    subtitle.textContent = ritual.subtitle;
    headingCopy.append(eyebrow, title, subtitle);

    const side = document.createElement('div');
    side.className = 'zb-quiz__result-side';
    const sideLabel = document.createElement('p');
    sideLabel.textContent = 'A secondary focus';
    const sideValue = document.createElement('strong');
    sideValue.textContent = concernLabels[concern];
    side.append(sideLabel, sideValue);
    heading.append(headingCopy, side);

    const intro = document.createElement('p');
    intro.className = 'zb-quiz__result-copy';
    intro.textContent = ritual.copy;

    const grid = document.createElement('div');
    grid.className = 'zb-quiz__result-grid';
    grid.append(
      resultBlock('WHY THIS RITUAL', ritual.why),
      resultBlock('BOTANICAL NOTE', ritual.botanical),
      resultSteps(ritual.steps),
    );

    const links = document.createElement('div');
    links.className = 'zb-quiz__result-links';
    const productLink = document.createElement('a');
    productLink.href = ritual.product.href;
    productLink.dataset.quizProduct = primary;
    productLink.textContent = `Explore ${ritual.product.title} ->`;
    const journalLink = document.createElement('a');
    journalLink.href = ritual.journal.href;
    journalLink.dataset.quizJournal = ritual.journal.href;
    journalLink.textContent = `${ritual.journal.title} ->`;
    const retake = createButton('RETAKE QUIZ', 'zb-quiz__retake', () => {
      state = defaultState();
      saveState();
      track('quiz_retake');
      renderQuestion();
    });
    links.append(productLink, journalLink, retake);
    resultEl.append(heading, intro, grid, links);
    track('quiz_completed', { primaryRitual: primary, secondaryConcern: concern });
    track('quiz_result_viewed', { primaryRitual: primary, secondaryConcern: concern });
  }

  function resultBlock(title, copy) {
    const block = document.createElement('div');
    block.className = 'zb-quiz__result-block';
    const heading = document.createElement('h3');
    heading.textContent = title;
    const paragraph = document.createElement('p');
    paragraph.textContent = copy;
    block.append(heading, paragraph);
    return block;
  }

  function resultSteps(steps) {
    const block = document.createElement('div');
    block.className = 'zb-quiz__result-block';
    const heading = document.createElement('h3');
    heading.textContent = 'A SIMPLE PRACTICE';
    const list = document.createElement('ul');
    steps.forEach((step) => {
      const item = document.createElement('li');
      item.textContent = step;
      list.appendChild(item);
    });
    block.append(heading, list);
    return block;
  }

  root.addEventListener('click', (event) => {
    const productLink = event.target.closest('[data-quiz-product]');
    const journalLink = event.target.closest('[data-quiz-journal]');
    if (productLink) track('quiz_product_clicked', { product: productLink.textContent, href: productLink.href });
    if (journalLink) track('quiz_journal_clicked', { href: journalLink.href });
  });

  if (state.index >= questions.length && state.answers.length === questions.length) {
    renderResult();
  } else {
    state.index = Math.min(state.index, questions.length - 1);
    renderQuestion();
  }

  track('quiz_started', { resumed: state.answers.length > 0 });
})();

